define('adminEmailAddressesListHeaderToolsView',[
  'module',
  'tableHeaderFieldView',
  'template!adminEmailAddressesListHeaderToolsView'
], function (
  Module,
  FieldView,
  Tpl
) {
  'use strict';

  // Empty header — no create button for email addresses.
  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-email-addresses-list-header-tools-view table-field-view'
  });
});

